import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-line-dialog',
  templateUrl: './delete-line-dialog.component.html',
  styleUrls: ['./delete-line-dialog.component.scss'],
})
export class DeleteLineDialogComponent {
  constructor(private dialog: MatDialogRef<DeleteLineDialogComponent>) {}

  save() {
    this.dialog.close(true);
  }

  close() {
    this.dialog.close(false);
  }
}
